const trainingCardList = () => {

    // Removed due to Ticket-642
    //const filterBtn = document.getElementById('training-card-filter-modal-btn');
    //const filterCountSpan = document.getElementById('filter-count-training');
    //const modal = document.getElementById('training-card-filter-modal');
    //const overlay = document.getElementById('training-card-overlay');
    //const closeModalBtn = document.getElementById('training-card-close-modal-btn');
    //const checkboxes = document.querySelectorAll('.filter-checkbox');
    //const acceptBtn = document.getElementById('training-card-accept-btn');
    //const resetBtn = document.getElementById('training-card-reset-btn');
    const showAllBtn = document.getElementById('training-cards-filter-list-show-all-btn');
    const listItems = document.querySelectorAll('#filter-workout-list-content .training-card-item');


    /***                              ***/
    /*** FILTER STATE CONTROLLERS    ***/
    /***                             ***/
    let selectedFilters = {
        targetgroup: [],
        accessibility: [],
        variants: [],
        validation: [],
        payment: []
    };

    // (NOTE) All logic for the modal & filter -> Removed due to Ticket-642
    //const openModal = () => {
    //    utils.common.showElement(modal);
    //    utils.common.showElement(overlay);
    //    utils.modal.trapFocus(modal);
    //    //filterBtn.setAttribute('aria-expanded', "true");
    //    overlay.setAttribute("aria-hidden", "false");
    //    closeModalBtn.setAttribute("aria-expanded", "true");
    //};

    //const closeModal = () => {
    //    utils.common.hideElement(modal);
    //    utils.common.hideElement(overlay);
    //    //filterBtn.setAttribute('aria-expanded', "false");
    //    overlay.setAttribute("aria-hidden", "true");
    //    closeModalBtn.setAttribute("aria-expanded", "false");
    //    utils.modal.removeTrapFocus();
    //};

    //filterBtn?.addEventListener("click", openModal);
    //closeModalBtn?.addEventListener("click", closeModal);
    //overlay?.addEventListener("click", closeModal);

    //acceptBtn?.addEventListener("click", () => {
    //    updateURL();
    //    closeModal();
    //});

    //resetBtn?.addEventListener("click", () => {
    //    checkboxes.forEach(checkbox => {
    //        checkbox.checked = false;
    //        checkbox.disabled = false;
    //    });
    //});

    // + sign or any other encoded values becomes spaces when taken from URL
    // Check for spaces make them dashed
    // Check for trailing dashes - remove them
    const normalizeValue = (input) =>
        decodeURIComponent(input || '')
            .toLowerCase()
            .replace(/\+/g, '')
            .replace(/\s+/g, '-')
            .replace(/^-+|-+$/g, '')
            .trim();

    //const checkmarkBoxes = () => {
    //    const urlParams = utils.url.checkUrlParams(Object.keys(selectedFilters))

    //    if (!urlParams) return

    //    let appliedFiltersCount = 0;

    //    checkboxes.forEach(checkbox => {
    //        const paramName = checkbox.dataset.id.toLowerCase();
    //        const checkboxValue = checkbox.dataset.value.toLowerCase().replace(/\s+/g, '-');

    //        checkbox.addEventListener('change', updateFilterOptions);
    //        if (urlParams.has(paramName) && urlParams.get(paramName)?.replace(/\s+/g, '-').split(',').includes(checkboxValue) && selectedFilters[paramName]) {
    //            checkbox.checked = true;
    //            selectedFilters[paramName].push(checkboxValue)
    //            appliedFiltersCount++;
    //        }
    //    });
    //    //if (filterCountSpan) utils.common.updateFilterButton(appliedFiltersCount, filterCountSpan);
    //};


    //const updateURL = () => {
    //    const urlParams = utils.url.checkUrlParams(Object.keys(selectedFilters), true)

    //    let appliedFiltersCount = 0;
    //    checkboxes.forEach(checkbox => {
    //        const parentDiv = checkbox.closest('div');
    //        const paramName = parentDiv.querySelector('h3').getAttribute('data-value');
    //        const paramValue = checkbox.dataset.value.toLowerCase();
    //        if (checkbox.checked) appliedFiltersCount++;
    //        utils.url.updateURLParameter(urlParams, paramName, paramValue, checkbox.checked);
    //    });

    //    const newUrl = utils.url.decodedUrl(urlParams);
    //    window.history.replaceState({}, '', newUrl);
    //    applyFilters();
    //    //if (filterCountSpan) utils.common.updateFilterButton(appliedFiltersCount, filterCountSpan);
    //};


    const applyFilters = () => {
        const urlParams = utils.url.checkUrlParams(Object.keys(selectedFilters));
        const container = document.getElementById("filter-workout-list-content");

        if (!container) return;

        const items = container.querySelectorAll('[data-id]');


        items.forEach(item => {
            let showItem = true;

            if (urlParams && urlParams.size > 0) {
                for (const [key, value] of urlParams.entries()) {
                    if (!selectedFilters.hasOwnProperty(key)) continue;
                    const paramValues = value
                        .toLowerCase()
                        .split(',')
                        .map(v => normalizeValue(v))
                        .filter(Boolean);

                    const rawItemValue = item.getAttribute(`data-${key}`);
                    
                    if (!rawItemValue) {
                        showItem = false;
                        break;
                    }

                    const itemValue = normalizeValue(rawItemValue);

                    if (!itemValue || !paramValues.includes(itemValue)) {
                        showItem = false;
                        break;
                    }
                }
            }

            if (!urlParams || urlParams.size === 0) {
                utils.common.showMoreItems(10, showAllBtn, listItems, true);
                if (showAllBtn) {
                    showAllBtn.closest('div').style.display = "flex"
                    showAllBtn.style.display = "flex";
                }
            } else {
                if (showAllBtn) {
                    showAllBtn.closest('div').style.display = "none"
                    showAllBtn.style.display = "none";
                }
                if (showItem) {
                    utils.common.showElement(item);
                } else {
                    utils.common.hideElement(item);
                }
            }
        });
    };



    //const updateFilterOptions = (event) => {
    //    const value = event.target.getAttribute('data-value').toLowerCase().replace(/\s+/g, '-');
    //    const type = event.target.getAttribute('data-id').toLowerCase();

    //    const isChecked = event.target.checked;

    //    if (!selectedFilters[type]) return
    //    if (isChecked) {
    //        selectedFilters[type] = [...selectedFilters[type], value];
    //    } else {
    //        selectedFilters[type] = selectedFilters[type].filter(item => item !== value);
    //    }

    //    updateFilterOptionsFN()
    //};

    //const updateFilterOptionsFN = () => {
    //    const objectMapping = Array.from(listItems).map(item => {
    //        return {
    //            targetgroup: item.getAttribute('data-targetgroup') ? item.getAttribute('data-targetgroup').toLowerCase().replace(/\s+/g, '-') : '',
    //            accessibility: item.getAttribute('data-accessibility') ? item.getAttribute('data-accessibility').toLowerCase().replace(/\s+/g, '-') : '',
    //            variants: item.getAttribute('data-variants') ? item.getAttribute('data-variants').toLowerCase().replace(/\s+/g, '-') : '',
    //            validation: item.getAttribute('data-validation') ? item.getAttribute('data-validation').toLowerCase().replace(/\s+/g, '-') : '',
    //            payment: item.getAttribute('data-payment') ? item.getAttribute('data-payment').toLowerCase().replace(/\s+/g, '-') : ''
    //        };
    //    });

    //    checkboxes.forEach(checkbox => {
    //        checkbox.disabled = false;
    //    });

    //    const filterAndDisableCheckboxes = (matchingItems) => {

    //        const matchingTargetGroups = matchingItems.map(mapping => mapping.targetgroup);
    //        const matchingAccessibility = matchingItems.map(mapping => mapping.accessibility);
    //        const matchingVariants = matchingItems.map(mapping => mapping.variants);
    //        const matchingValidations = matchingItems.map(mapping => mapping.validation);
    //        const matchingPaymentMethods = matchingItems.map(mapping => mapping.payment);

    //        checkboxes.forEach(checkbox => {
    //            const checkboxType = checkbox.getAttribute('data-id').toLowerCase();
    //            const checkboxValue = checkbox.getAttribute('data-value').toLowerCase().replace(/\s+/g, '-');
    //            if (checkboxType === 'targetgroup') {
    //                checkbox.disabled = !matchingTargetGroups.includes(checkboxValue);
    //            } else
    //                if (checkboxType === 'accessibility') {
    //                    checkbox.disabled = !matchingAccessibility.includes(checkboxValue);
    //                } else if (checkboxType === 'variants') {
    //                    checkbox.disabled = !matchingVariants.includes(checkboxValue);
    //                }
    //                else if (checkboxType === 'validation') {
    //                    checkbox.disabled = !matchingValidations.includes(checkboxValue);
    //                } else if (checkboxType === 'payment') {
    //                    checkbox.disabled = !matchingPaymentMethods.includes(checkboxValue);
    //                }
    //        });
    //    };
    //    const getMatchingItems = () => {
    //        return objectMapping.filter(mapping =>
    //            (selectedFilters.targetgroup.length === 0 || selectedFilters.targetgroup.includes(mapping.targetgroup)) &&
    //            (selectedFilters.accessibility.length === 0 || selectedFilters.accessibility.includes(mapping.accessibility)) &&
    //            (selectedFilters.variants.length === 0 || selectedFilters.variants.includes(mapping.variants)) &&
    //            (selectedFilters.validation.length === 0 || selectedFilters.validation.includes(mapping.validation)) &&
    //            (selectedFilters.payment.length === 0 || selectedFilters.payment.includes(mapping.payment))
    //        );
    //    };


    //    // Reset filters if all checked filters are empty
    //    if (
    //        selectedFilters['targetgroup'].length === 0 &&
    //        selectedFilters['accessibility'].length === 0 &&
    //        selectedFilters['variants'].length === 0 &&
    //        selectedFilters['validation'].length === 0 &&
    //        selectedFilters['payment'].length === 0
    //    ) {
    //        return resetAllFilters();
    //    }

    //    const matchingItems = getMatchingItems();
    //    filterAndDisableCheckboxes(matchingItems);
    //}

    //checkboxes.forEach(checkbox => {
    //    checkbox.addEventListener('change', updateFilterOptions);
    //});


    /***                    ***/
    /***** FILTER HELPERS *****/
    /***                   ***/

    // Function to reset all filters and show all options
    //const resetAllFilters = () => {
    //    // Reset checkedFilters to be empty
    //    selectedFilters = {
    //        targetgroup: [],
    //        accessibility: [],
    //        variants: [],
    //        validation: [],
    //        payment: []
    //    };

    //    listItems.forEach(element => {
    //        element.disabled = false;
    //        element.checked = false;
    //    });
    //};
    const initTargetGroupFilter = () => {
        const url = window.location.href;
        const pathSegments = new URL(url).pathname.split('/');

        // Keywords for "prices" in different languages
        const keywords = ["prices", "priser", "hinnat", "prijzen", "tarifs"];
        // English, Swedish, Danish, Finnish, Dutch, French


        const targetSegment = pathSegments.find(segment =>
            keywords.some(keyword => segment.toLowerCase().includes(keyword))
        );
        if (!targetSegment) {
            return;
        }

        const targetGroupElements = document.querySelectorAll('[data-id="targetgroup"]');
        if (targetGroupElements.length === 0) return;
        const urlParams = utils.url.checkUrlParams(Object.keys(selectedFilters), true);
        const hasAnyTargetGroup = urlParams.has('targetgroup');

        if (!hasAnyTargetGroup) {
            let defaultItem = null;
            let firstItem = null;

            targetGroupElements.forEach((checkbox, index) => {
                if (checkbox.dataset.default === 'true') {
                    defaultItem = checkbox.dataset.value.toLowerCase().replace(/\s+/g, '-');
                }
                if (index === 0) {
                    firstItem = checkbox.dataset.value.toLowerCase().replace(/\s+/g, '-');
                }
            });

            if (defaultItem) {
                urlParams.set('targetgroup', defaultItem);
            } else if (firstItem) {
                urlParams.set('targetgroup', firstItem);
            }

            const newUrl = utils.url.decodedUrl(urlParams);
            window.history.replaceState({}, '', newUrl);
        }

        targetGroupElements.forEach(checkbox => {
            const label = checkbox.nextElementSibling; // Select the <label> sibling
            const tabBar = checkbox.closest('li').querySelector('[data-type="tab-bar"]');
            const selectedTargetGroup = normalizeValue(urlParams.get('targetgroup'));
            const checkboxValue = normalizeValue(checkbox.dataset.value);

            if (selectedTargetGroup === checkboxValue) {
                checkbox.checked = true;
                // Update label class
                label.classList.add('text-text-brand');
                label.classList.remove('text-text-soft');

                // Update tab-bar class
                tabBar.classList.add('bg-brand');
                tabBar.classList.remove('bg-secondary-surface');
            } else {
                // Update label class
                label.classList.add('text-text-soft');
                label.classList.remove('text-text-brand');

                // Update tab-bar class
                tabBar.classList.add('bg-secondary-surface');
                tabBar.classList.remove('bg-brand');
            }

            checkbox.addEventListener('change', event => {
                const dynamicUrlParams = utils.url.checkUrlParams(Object.keys(selectedFilters), true);

                const value = event.target.getAttribute('data-value').toLowerCase().replace(/\s+/g, '-');
                const isChecked = event.target.checked;
                const label = event.target.nextElementSibling; // Select the <label> sibling
                const tabBar = event.target.closest('li').querySelector('[data-type="tab-bar"]');

                if (isChecked) {
                    // Set the new targetgroup and clear any others
                    dynamicUrlParams.set('targetgroup', value);
                    targetGroupElements.forEach(cb => {
                        if (cb !== event.target) {
                            cb.checked = false;
                            const otherLabel = cb.nextElementSibling;
                            const otherTabBar = cb.closest('li').querySelector('[data-type="tab-bar"]');

                            // Reset styles for deselected elements
                            otherLabel?.classList.add('text-text-soft');
                            otherLabel?.classList.remove('text-text-brand');
                            otherTabBar?.classList.add('bg-secondary-surface');
                            otherTabBar?.classList.remove('bg-brand');
                        }
                    });

                    // Update styles for the selected checkbox
                    label?.classList.add('text-text-brand');
                    label?.classList.remove('text-text-soft');
                    tabBar?.classList.add('bg-brand');
                    tabBar?.classList.remove('bg-secondary-surface');
                }

                const newUrl = utils.url.decodedUrl(dynamicUrlParams);
                window.history.replaceState({}, '', newUrl);

                applyFilters();
            });
        });
    };


    //checkmarkBoxes();
    initTargetGroupFilter();
    applyFilters();
    //updateFilterOptionsFN();

};
document.addEventListener('DOMContentLoaded', trainingCardList);
